export default __webpack_public_path__ + "53654c12b02291e7968c64dc898baecc.jpeg";